import axios from 'axios'
import { url } from '@/api/url'
import { HeadersWithCredentials, headersWithoutCredentials } from '@/api/header'

export const verifySignUpEmail = async ({ email, code }) => {
    return await axios.post(
        `${url}/user/subscription/verify-email`,
        { email, code },
        {
            withCredentials: true,
            headers: headersWithoutCredentials,
        },
    )
}
export const resendVerificationEmailCode = async (email) => {
    return await axios.post(
        `${url}/user/subscription/resend-code`,
        { email },
        {
            withCredentials: true,
            headers: headersWithoutCredentials,
        },
    )
}
export const signUp = async (newUser) => {
    return await axios.post(`${url}/user/subscription`, newUser, {
        withCredentials: true,
        headers: headersWithoutCredentials,
    })
}

export const login = async (email, password) => {
    return await axios.post(
        `${url}/user/connect`,
        { email, password },
        {
            headers: headersWithoutCredentials,
        },
    )
}

export const loginVerifyEmail = async (email, code) => {
    return await axios.post(
        `${url}/user/connect/verify-email`,
        { email, code },
        {
            headers: headersWithoutCredentials,
        },
    )
}

export const loginResendCode = async (email) => {
    return await axios.post(
        `${url}/user/connect/resend-code`,
        { email },
        {
            headers: headersWithoutCredentials,
        },
    )
}

/** Login step 2 for accounts with two-factor authentication: the 6-digit code emailed by /user/connect + the session id it returned. */
export const loginVerifyOtp = async (email, code, otpSessionId) => {
    return await axios.post(
        `${url}/user/connect/verify-otp`,
        { email, otpCode: code, otpSessionId },
        {
            headers: headersWithoutCredentials,
        },
    )
}

export const loginResendOtp = async (email, otpSessionId) => {
    return await axios.post(
        `${url}/user/connect/resend-otp`,
        { email, otpSessionId },
        {
            headers: headersWithoutCredentials,
        },
    )
}

export const loginWithToken = async (token) => {
    return await axios.post(
        `${url}/user/connect-with-token`,
        { token },
        {
            headers: headersWithoutCredentials,
        },
    )
}

export const ResetpasswordSendEmail = async (email) => {
    return await axios.put(
        `${url}/user/resetpassword`,
        { email, subject: 'reset password Scoring.fit' },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const ResetpasswordVerifyKey = async (email, key) => {
    return await axios.put(
        `${url}/user/resetpassword/check`,
        { email, key },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const ResetpasswordChangeLogin = async (email, key, password, repeatPassword) => {
    return await axios.put(
        `${url}/user/resetpassword/changelogin`,
        { email, key, password, repeatPassword },
        {
            headers: HeadersWithCredentials(),
        },
    )
}
